export interface PaymentMethod {
  id: string;
  key: string;
  description: string;
  autoPay: boolean;
  autoPayYesNo: string;
}
